import { NONE_TEXT } from '@/components/displayFields/AxleInfoField';
import { Typography, TypographyProps } from '@mui/material';

export type NoneLabelProps = { text?: string } & TypographyProps;
export const NoneLabel = ({ text = NONE_TEXT, ...rest }: NoneLabelProps) => {
    return (
        <Typography color='text.disabled' {...rest}>
            {text}
        </Typography>
    );
};
